<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="create()">Create Location</button>
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search Locations..."' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
</div>

<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable
    #packageTable
    class='material striped datatable'
    [rows]='displayLocations'
    [columnMode]='"force"'
    [headerHeight]='40'
    [sorts]="[{prop: 'id', dir: 'desc'}]"
    [footerHeight]='20'
    [scrollbarH]="true"
    [scrollbarV]="true"
    [rowHeight]="40"
    [reorderable]="true">

    <ngx-datatable-column prop="name" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Location Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.name}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="description" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Time Zone
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.timeZone}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                City / State
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.address?.city}}, {{row.address?.stateProvince}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="dateCreated" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Date Created
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.dateCreated | date:'EEEE, MMMM d, y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="130" [maxWidth]="130">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button tooltip="Edit" class="btn btn-success btn-icon" (click)="edit(row.locationId)"><i class="flaticon-edit-1"></i></button>
            <button tooltip="Delete" class="btn btn-danger btn-icon" (click)="delete(row.locationId)"><i class="flaticon-cancel"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>
